import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20romantic%20dreamy%20sunset%20scene%20over%20a%20calm%20ocean%20with%20a%20small%20heart-shaped%20island%20silhouette%20soft%20pink%20and%20golden%20gradient%20sky%20fluffy%20clouds%20artistic%20illustration%20style%20warm%20atmosphere%20peaceful%20and%20romantic%20composition&width=1600&height=900&seq=hero-main-bg-2026&orientation=landscape"
          alt="爱情岛网站 - 在线交友娱乐平台"
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/45"></div>

      <div className="relative z-10 w-full container-page text-center">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-heading font-bold text-white leading-tight mb-6">
            遇见爱情，<br className="md:hidden" />从
            <span style={{ fontFamily: "'Dancing Script', cursive" }} className="text-accent-300">
              爱情岛
            </span>
            开始
          </h1>
          <p className="text-base md:text-lg text-white/80 leading-relaxed max-w-xl mx-auto mb-10">
            爱情岛网站是深受用户喜爱的在线交友与娱乐平台，提供智能匹配、即时通讯、动态社区等丰富功能，
            为500万+用户打造安全可靠的交友环境。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="#"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all duration-300 cursor-pointer shadow-lg shadow-primary-500/30"
            >
              免费注册
            </a>
            <Link
              to="/category"
              className="whitespace-nowrap w-full sm:w-auto px-8 py-3.5 rounded-full text-base font-medium border-2 border-white/40 text-white hover:bg-white/15 transition-all duration-300 cursor-pointer"
            >
              了解更多
            </Link>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <div className="w-8 h-8 flex items-center justify-center text-white/60">
          <i className="ri-arrow-down-line text-2xl"></i>
        </div>
      </div>
    </section>
  );
}